import axios from 'axios';

const updateResponseSettings = params => {
  return axios.put('responses/settings', params);
};

export { updateResponseSettings };
